import { setLocaleObjectNamespace } from "../../../common/src/setLocaleObjectNamespace";

export default setLocaleObjectNamespace("settings", {
    textColor: "Основной цвет текста",
    backgroundColor: "Цвет фона",
    replace: "Заменить",
    uploadBackgroundImage: "Загрузить фоновое изображение",
    backgroundFixed: "Зафиксировать фоновое изображение",
    backgroundFixedTooltip: "Изображение будет растягиваться только в пределах видимости экрана",
    showCountdown: "Показывать обратный отсчёт поверх постера в плеере",
    borderRadiusSize: "Скругления углов",
    goToQuizListPage: "Открыть список квизов",
    saveSettings: 'Сохранить настройки',
    view: 'Вид',
    orientation: 'Ориентация',
    backgroundOpacity: 'Прозрачность основного фона',
    additionalColor: 'Второстепенный цвет',
    elementsRounding: 'Скругление элементов',
    substrateOpacity: 'Прозрачность фона у подложки',
    cardOpacity: 'Прозрачность фона у карточки',
    showFormat: 'Показывать формат',
    showFormatInCards: 'Показывать формат в карточках',
    showMembersPhoto: 'Показывать фотографии спикеров и модераторов в карточках',
    showMembersGroupAndName: 'Показывать названия групп и имена спикеров и модераторов в карточках',
    showDelay: 'Показывать перерывы',
    showTags: 'Показывать теги',
    showLogos: 'Показывать логотипы',
    gridCardHeight: 'Высота карточек в виде "Сеткой"',
    gridCardHeightHint: 'Пикселей в минуте',
    showTitle: 'Показывать заголовок',
    title: 'Заголовок',
    titleSize: 'Размер заголовка',
    textSize: "Размер текста",
    showSubtitle: "Показывать подзаголовок",
    subtitle: "Подзаголовок",
    subtitleSize: "Размер подзаголовка",
    typeFileName: 'Введите название файла',
    uploadBackground: 'Загрузить фон',
    uploadHeader: 'Загрузить шапку',
    wrongFileFormat: 'Неверный формат файла',
    exesAllowableSize: 'Размер файла превышает допустимый размер',
    backgroundImageHint: 'Формат файла - jpg, png, bmp',
    confirmImageRemove: 'Вы уверены, что хотите удалить фото?',
    fileTypeNotMatch: 'Тип файла не соответствует требованиям',
    additionalTextColor: 'Второстепенный цвет текста',
    backgroundTooltipText: "Формат файла - jpg, png, bmp",
    showDate: "Отображать дату",
    left: "Слева",
    center: "По центру",
    right: "Справа",
    headingPositioning: "Позиционирование заголовка и подзаголовка",
    goHallSettings: "Перейти в настройки залов",
    blockPlayer: "Плеер",
    blockDescription: "Расписание зала",
    blockEpisodes: "Описание текущего эпизода",
    errorMessage: "Произошла ошибка, попробуйте снова",
    showSubstrate: "Показывать подложку",
    gridCardHeightSize: "Высота плиток",
    gridCardHeightSizeTooltip: "Количество пикселей в минуте",
    pdfExportEnabled: "Показывать кнопку Скачать PDF",
    showOrganizationSearch: "Показывать поиск по организации",
    showStatuses: "Показывать статус",
    showBigPhotos: "Показывать большие фотографии",
    alignPhotoCenter: "Выравнивать фотографии по центру",
    player: "Трансляция",
    showPlayerOffline: "Разрешить просмотр трансляции оффлайн участникам",
    format: 'Формат',
    a4: 'A4',
    fullpage: 'Полностраничный',
    showEpisodeExpanded: 'Показывать карточки в развёрнутом виде',
    placeholderTips: "Подсказки для плейсхолдеров",

    'delay.title': 'Настройки перерыва',
    'delay.showTime': 'Показывать время в перерыве',
    'delay.largeFont': 'Шрифт отображать крупно',
    'delay.cardColor': 'Цвет карточки перерыва',

    'hint.timeAndFullname': 'Время и ФИО в карточках',
    'hint.textColor': 'Заголовки залов в шапке таблицы, названия эпизодов в карточках, заголовки залов в карточках, время слева от таблицы',

    'color.date': 'Цвет даты в заголовке таблицы',
    'color.card': 'Цвет карточки',
    'color.accentStyleButton': 'Кнопка Задать вопрос Акцентным цветом',

    'show.block': 'Отображать блок',
    'show.formats': 'Показывать формат мероприятия',
    'show.block.displayHall': 'Отображать в залах',
    'show.block.expanded': 'Показывать блок в развёрнутом виде',

    'tab.title.common': 'Общие настройки',
    'tab.title.blocks': 'Настройки блоков',

    'blocks.player': 'Плеер',
    'blocks.hall-episodes': 'Расписание зала',
    'blocks.hall-description': 'Описание эпизода',
    'blocks.legacy-banners': 'Баннеры',
    'blocks.text-block': 'Текстовый блок',
    'blocks.buttons': 'Кнопки',
    'blocks.poster': 'Постер',
    'blocks.countdown': 'Обратный отсчет',
    'blocks.activity-rating': 'Рейтинг участников',
    'blocks.partners': 'Партнеры',
    'blocks.cover': 'Обложка',
    'blocks.quizzes': 'Квизы',
    'blocks.shop': 'Магазин призов',
    'blocks.custom-widget': 'Виджет',

    'add.block': 'Добавить новый блок',

    'placeholder.title': 'Введите название заголовка',

    'confirm.removeBlock': 'Вы уверены, что хотите удалить блок?',

    'error.blockAlreadyExists': 'Блок с таким типом может быть только один на странице',
    'scheduleButton': 'Кнопка расписания',
    'scheduleButton.show': 'Отображать кнопку расписания',
    'scheduleButton.title': 'Название кнопки расписания',
    'pixelsInMinute': 'Количество пикселей в минуте',
    
    'diffStartTimeout.title': 'Показывать обратный отсчёт до мероприятия за',
    'diffStartTimeout.hour': '1 час',
    'diffStartTimeout.day': '1 день',
    'diffStartTimeout.week': '7 дней',
    'diffStartTimeout.month': '30 дней',

    'mobileOpenModule': 'Открывать на мобильных устройствах по умолчанию вкладку с интерактивами',

    'question.title': 'Настройки вопросов',
    'question.hide': 'Отключить отображение блока вопросов',
    'question.allowReceiveQuestions': 'Включить прием вопросов',

    'timeoutFormat': 'Формат счетчика',
    'timeoutFormat.dd_hh_mm_ss': 'Дни, Часы, Минуты, Секунды',
    'timeoutFormat.dd_hh_mm': 'Дни, Часы, Минуты',
    'timeoutFormat.emptyVisibleDay': 'Когда останется 0 дней (менее 24 часов), показывать Часы, Минуты, Секунды',

    'partners.addPartner': 'Добавить партнера',
    'partners.removePartner': 'Удалить партнера',
    'partner.title': 'Партнер',
    'partner.name': 'Название',
    'partner.logo': 'Логотип',
    'partner.backgroundColor': 'Цвет фона',
    'partner.url': 'Ссылка',

    'cover.dateEvent': 'Дата мероприятия',
    'cover.showDateEvent': 'Показать дату мероприятия',
    'cover.timeEvent': 'Время мероприятия',
    'cover.showTimeEvent': 'Показать время мероприятия',
    'cover.participationType': 'Формат мероприятия',
    'cover.showParticipationType': 'Показать формат мероприятия',

    'allowedPhoneCountryCodes.title': 'Разрешенные телефонные коды стран',
    'allowedPhoneCountryCodes.add': 'Добавить',
    'allowedPhoneCountryCodes.buttonOpen': 'Доступные страны для отправки СМС',

    'webHooks.title': 'Сервис web hook',
    'webHooks.remove': 'Удалить?',
    'webHooks.add': 'Добавить web hook',
    'webHooks.method': 'Метод запроса',
    'webHooks.deliveryFormat': 'Формат',
    'webHooks.headers': 'Заголовки',
    'webHooks.addHeader': 'Добавить заголовок',
    'webHooks.key': 'Ключ',
    'webHooks.value': 'Значение',

    'viewTypeRestriction.listType': 'Тип списка',
    'viewTypeRestriction.none': 'Не выбран',
    'viewTypeRestriction.whitelist': 'Белый список',
    'viewTypeRestriction.blacklist': 'Черный список',
    'viewTypeRestriction.emptyList': 'Список пуст',
    'viewTypeRestriction.selectType': 'Выберите тип списка',
    'viewTypeRestriction.byIp.title': 'Ограничение просмотра по IP',
    'viewTypeRestriction.byIp.hint': 'Просмотр будет разрешён только с выбранных IP и диапазонов',
    'viewTypeRestriction.byIp.button': 'Добавить IP-адрес',
    'viewTypeRestriction.byIp.confirm': 'Вы уверены, что хотите удалить IP-адрес?',
    'viewTypeRestriction.byIp.validationHint': 'IP-адрес должен быть вида "192.168.1.1" или "192.168.1.0-192.168.1.24" или "192.168.1.0/24"',
    'viewTypeRestriction.byCountry.title': 'Ограничение просмотра по странам',
    'viewTypeRestriction.byCountry.hint': 'Просмотр будет разрешён только из выбранных стран',
    'viewTypeRestriction.byCountry.button': 'Добавить страну',
    'viewTypeRestriction.byCountry.confirm': 'Вы уверены, что хотите удалить выбранную страну?',

    sidebarPosition: 'Расположение чата',
    bottom: 'Внизу',
    right: 'Справа',
});
